module.exports = "images/enfants_3.df0166e7.png";